import React from 'react';
import './App.css';
import {HashRouter as Router, Switch, Route, Link} from "react-router-dom";
import {Navbar,Nav,NavDropdown,Image} from 'react-bootstrap';
import Home from "./home.js";
import NotFound from "./notFound.js";
import FixedFooter from "./fixedFooter.js";
import RelativeFooter from "./relativeFooter.js";
import People from "./people.js";
import Overview from "./overview.js";
import Hardware from "./hardware.js"
import Communications from "./communications.js"
import SignalProcessing from "./signalProcessing.js"
import EventDetection from "./eventDetection.js"

const App = () => {
  return (
    <div id="container">
      <Router>
        <header>
          <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
            <Navbar.Brand as={Link} to="/home">
              <Image src="img/UW-logo.png" alt="University of Washington Logo" fluid/>
              CSE/ECE 475: Embedded Systems Capstone
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link as={Link} to="/people">People</Nav.Link>
                <Nav.Link as={Link} to="/overview">Project Overview</Nav.Link>
                <NavDropdown title="Project Components" id="basic-nav-dropdown">
                  <NavDropdown.Item as={Link} to="/hardware">Hardware Setup</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/signal-processing">Signal Processing</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/event-detection">Event Detection</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/communications">Communications & Displays</NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </header>
        <Switch>
          <Route path="/" component={Home} exact={true} />
          <Route path="/home" component={Home} exact={true} />
          <Route path="/people" component={People} exact={true} />
          <Route path="/overview" component={Overview} exact={true} />
          <Route path="/hardware" component={Hardware} exact={true} />
          <Route path="/signal-processing" component={SignalProcessing} exact={true} />
          <Route path="/event-detection" component={EventDetection} exact={true} />
          <Route path="/communications" component={Communications} exact={true} />
          <Route path="/*" component={NotFound} exact={true} />
        </Switch>
        <Switch>
          <Route path="/" component={RelativeFooter} exact={true} />
          <Route path="/home" component={RelativeFooter} exact={true} />
          <Route path="/people" component={RelativeFooter} exact={true} />
          <Route path="/overview" component={RelativeFooter} exact={true} />
          <Route path="/hardware" component={RelativeFooter} exact={true} />
          <Route path="/signal-processing" component={RelativeFooter} exact={true} />
          <Route path="/event-detection" component={RelativeFooter} exact={true} />
          <Route path="/communications" component={RelativeFooter} exact={true} />
          <Route path="/*" component={FixedFooter} exact={true} />
        </Switch>
      </Router>
    </div>
  )
}

export default App;
